import React, { Fragment, useContext, useEffect } from "react";

// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";
import { NativeAction } from "../../modules/utils/HandleWs";
import { userHabit } from "../../modules/utils/UserHabit";

// UI
import { ContainerNew, SubMenu } from "../Layout";

import styled from "styled-components";
import { RightMenuLayer } from "./RightMenuLayer";
import useTitle from "../../modules/hooks/useTitle";

export default props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  useTitle("마이페이지_약관_목록");

  useEffect(() => {
    userHabit(phonecfg, "TP100");
    NativeAction(phonecfg, "statusColor", "#A5AEE4");
  }, [phonecfg.version]);

  return (
    <Fragment>
      <ContainerNew
        Title={"약관"}
        dark={"dark"}
        leftMenu={SubMenu}
        goToUrl={"/mp/settings/0"}>
        <div className="contents">
          <div className="sub-contents">
            <div style={{ borderTop: "1px solid #000000" }}>
              <DivStyle onClick={() => _O.Open("/mp/termsView/service")}>
                서비스이용약관
              </DivStyle>
              <DivStyle onClick={() => _O.Open("/mp/termsView/priv")}>
                개인정보처리방침
              </DivStyle>
              <DivStyle onClick={() => _O.Open("/mp/termsView/geo")}>
                위치기반서비스이용약관
              </DivStyle>
            </div>
          </div>
        </div>
      </ContainerNew>

      <RightMenuLayer />
    </Fragment>
  );
};

const DivStyle = styled.div`
  height: 58px;
  line-height: 58px;
  border-bottom: 1px solid #a2a2a2;
  font-weight: 600;
`;
